export default class CatalogPriceGroup {
  AllowChangeRequestForPriceGroups: boolean
  CatalogCode: number
  CurrencyCode: string
  Description: string
  Id: number
  IsEditable: number
  Name: string
  SortOrder: number
  StateId: number
  StateRank: number
  Status: number

  constructor(obj: CatalogPriceGroup) {
    this.AllowChangeRequestForPriceGroups = !!obj.AllowChangeRequestForPriceGroups
    this.CatalogCode = obj.CatalogCode
    this.CurrencyCode = obj.CurrencyCode
    this.Description = obj.Description
    this.Id = obj.Id
    this.IsEditable = obj.IsEditable
    this.Name = obj.Name
    this.SortOrder = obj.SortOrder
    this.Status = obj.Status
    this.StateId = obj.StateId
    this.StateRank = obj.StateRank
  }
}
